import React, { useContext } from 'react'
import { motion } from 'framer-motion'
import { GenericModal } from '@pinflag/pinflag-ui-kit'

import { DataContext } from '../../context/DataContext'
import { useShopify } from '../../hook/useShopify'

import AddressStep from './AddressStep'
import ShippingMethodStep from './ShippingMethodStep'
import PickupMapStep from './PickupMapStep'

const ShippingOptionRenderer = () => {
  const {
    steps,
    setSteps,
    selectedShippingMethod,
    addressInfo,
    setCurrentStep,
    setIsProductSoldOut,
    isProductSoldOut
  } = useContext(DataContext)

  const { redirectToCartShopify } = useShopify()

  const handleDeliveryStepChange = () => {
    const updatedSteps = [...steps]
    updatedSteps[0].completed = true
    updatedSteps[1].disabled = false
    updatedSteps[1].subSteps[0].completed = true
    updatedSteps[1].subSteps[1].completed = true
    updatedSteps[1].subSteps[2].completed = true
    updatedSteps[1].completed = true
    setSteps(updatedSteps)
    setCurrentStep(3)
  }

  const renderPhaseContent = () => {
    const currentStep = steps[1]
    const { subSteps } = currentStep

    if (!subSteps[0].completed || !addressInfo.userAddress) {
      return <AddressStep />
    } else if (!subSteps[1].completed && addressInfo.userAddress) {
      return <ShippingMethodStep />
    } else if (!subSteps[2].completed && selectedShippingMethod && !selectedShippingMethod.includes('delivery')) {
      return <PickupMapStep />
    } else if (selectedShippingMethod && selectedShippingMethod.includes('delivery')) {
      handleDeliveryStepChange()
    }
  }

  const handleClose = () => {
    setIsProductSoldOut(false)
    redirectToCartShopify()
  }

  return (
    <>
      <GenericModal
        isOpenModal={isProductSoldOut}
        icon='error'
        modalTitle='Producto agotado'
        modalText='Uno de tus productos está agotado. Debes dirigirte al carro.'
        secondButton='Volver al carro'
        handleAction={handleClose}
      />
      <div className="relative md:h-full bg-slate-100 flex flex-col">
        <motion.div className="relative">
          {renderPhaseContent()}
        </motion.div>
      </div>
    </>
  )
}

export default ShippingOptionRenderer
